var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"lemon shadow-sm",attrs:{"src":'/svg/lemonTree/' + _vm.img,"alt":"lemonTree"}})])}
var staticRenderFns = []

export { render, staticRenderFns }